"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardReplacements = void 0;
exports.standardReplacements = {
    'rssi': 'RSSI',
    'snr': 'SNR',
    'sf': 'SF',
    'dr': 'DR',
    'adr': 'ADR',
    'esp': 'ESP',
};
